import {Injectable} from '@angular/core';
import {HoomvipStorage} from '../hoomvip-storage/hoomvip-storage.service';

declare const Weglot: any;

@Injectable({providedIn: 'root'})
export class LangService {
  constructor(private hoomvipStorage: HoomvipStorage) {
  }

  public currentLang(): string {
    return this.hoomvipStorage.currentLang();
  }

  public setCurrentLang(lang: string): void {
    return this.hoomvipStorage.setCurrentLang(lang);
  }

  public translateDynamic(element?: HTMLElement): void {
    const w = (window as any).Weglot;
    if (w && w.initialized && typeof w.addNodes === 'function') {
      try {
        w.addNodes(element);
      } catch (err) {
        console.error('Error calling Weglot.addNodes:', err);
      }
    }
  }

  public translateText(text: string, targetLang?: string): Promise<string> {
    const w = (window as any).Weglot;
    if (w && w.initialized && typeof w.translate === 'function') {
      const destLang = targetLang || this.currentLang();
      return w.translate({
        words: [{ t: 1, w: text }],
        languageTo: destLang
      }).then((translations: string[]) => {
        return translations && translations.length > 0 ? translations[0] : text;
      }).catch((err: any) => {
        console.error('Weglot translate error:', err);
        return text;
      });
    }
    return Promise.resolve(text);
  }
}
